import React from "react"
import { StaticQuery, graphql, Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'

class NavMobile extends React.Component 
{
    constructor(props) {
        super(props);
        this.state = {
            showMobile: false,
            navChild: ''
        }
    }

    handleClose = event => {
        event.preventDefault();
		this.setState({
			showMobile: false,
        })
    }
    
    handleOpen = event => {
        event.preventDefault();
		this.setState({
			showMobile: true,
        })
    }

    handleNavChild = event => {
        event.preventDefault();
        let target = event.target.getAttribute('data-id');
        if (this.state.navChild === target) { 
            this.setState({
                navChild: ''
            });
        } else {
            this.setState({
                navChild: target
            })
        }
    }

    render () {
        function getSection (allMarkdownRemarkGroup, section) {
            let result = [];
            for (let edges of allMarkdownRemarkGroup) {
                for (let item of edges.edges) {
                    if (item.node.frontmatter.section === section) {
                        result.push(item.node)
                    }
                }
            }
            result.sort(function(a, b) {
                return a.frontmatter.nav_order - b.frontmatter.nav_order;
            });
            return result;
        }
        
        const MobileNavSection = (p) => <ul className={this.state.navChild === `${p.navChild}` ? `show` : ``}>
            {p.mobileNavSectionItems.map( (p, i) => (<li key={i}><Link to={p.fields.slug}>{p.frontmatter.title}</Link></li>) )}
        </ul>

        const NavSection = (p) => <ul>
            {p.navSectionItems.map( (p, i) => (<li key={i}><Link to={p.fields.slug}>{p.frontmatter.title}</Link></li>) )}
        </ul>

        return (
            <div className="layout">
                <div className={this.state.showMobile ? 'nav__mobile--show' : 'nav__mobile--hide'}>
                    <div className="nav__mobile--overlay"></div>
                    <div className="nav__mobile--close">
                        <button className="nav__mobile--close__link" onClick={this.handleClose}>Close ×</button>
                    </div>
                    <div className="nav__mobile">
                        <nav className="nav__mobile--content">
                            <ul>
                                <li className="nav__child"><button onClick={this.handleNavChild} data-id="child_1" title="Painting">Painting&nbsp;&nbsp;{this.state.navChild === `child_1` ? `×` : `+`}</button>
                                    <MobileNavSection navChild="child_1" mobileNavSectionItems={getSection(this.props.data.group, 'painting')} />
                                </li>
                                <li className="nav__child"><button onClick={this.handleNavChild} data-id="child_2" title="Pricing">About&nbsp;&nbsp;{this.state.navChild === `child_2` ? `×` : `+`}</button>
                                    <MobileNavSection navChild="child_2" mobileNavSectionItems={getSection(this.props.data.group, 'about')} />
                                </li>
                                <li className="nav__child"><button onClick={this.handleNavChild} data-id="child_3" title="Gallery">Gallery&nbsp;&nbsp;{this.state.navChild === `child_3` ? `×` : `+`}</button>
                                    <MobileNavSection navChild="child_3" mobileNavSectionItems={getSection(this.props.data.group, 'gallery')} />
                                </li>
                                <li><Link to="/contact/">Contact</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="layout grey">
                    <div className="layout__container">
                        <div className="layout__wide">
                            <div className="grid grid__1-3 grid__gap--48 align__items">
                                <div className="logo center">
                                    <BackgroundImage fluid={this.props.logo.childImageSharp.fluid}>
                                        <h2><Link to='/'>Abbey Road<br />Painters</Link></h2>
                                    </BackgroundImage>
                                </div>
                                <div className="nav nav__off">
                                    <ul className="sf__menu">
                                        <li className="nav__dropdown"><Link to='/painting-and-decorating/' className="nav__arrow">Painting &nbsp;<img src="/img/drop__down.svg" alt="arrow"/></Link>
                                            <NavSection navSectionItems={getSection(this.props.data.group, 'painting')} />
                                        </li>
                                        <li className="nav__dropdown"><Link to='/about/' className="nav__arrow">About &nbsp;<img src="/img/drop__down.svg" alt="arrow"/></Link>
                                            <NavSection navSectionItems={getSection(this.props.data.group, 'about')} />
                                        </li>
                                        <li className="nav__dropdown"><Link to='/gallery/' className="nav__arrow">Gallery &nbsp;<img src="/img/drop__down.svg" alt="arrow"/></Link>
                                            <NavSection navSectionItems={getSection(this.props.data.group, 'gallery')} />
                                        </li>
                                        <li><Link to='/contact/'>Contact</Link></li>
                                    </ul>
                                    <ul>
                                        <li className="phone"><a href="tel:0800220444" title="0800 220 444" rel="nofollow noopener">0800 220 444</a></li>
                                        <li className="phone"><a href="tel:021324000" title="021 324 000" rel="nofollow noopener">Mike 021 324 000</a></li>
                                    </ul>
                                </div>
                                <div className="nav__top nav__mobile__on">
                                    <ul>
                                        <li className="nav__button"><button title="Menu" onClick={this.handleOpen} className="nav__hamburger--toggle">&#9776; Menu</button></li>
                                    </ul>
                                    <ul>
                                        <li className="phone"><a href="tel:0800220444" title="0800 220 444" rel="nofollow noopener">0800 220 444</a></li>
                                        <li className="phone"><a href="tel:021324000" title="021 324 000" rel="nofollow noopener">Mike 021 324 000</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
  
export default () => (
    <StaticQuery
        query={graphql`
            query {
                logo: file(relativePath: { eq: "logo.png" }) {
                    childImageSharp {
                        fluid(maxWidth: 480) {
                            ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                    }
                }
                allMarkdownRemark {
                    group(field: frontmatter___section) {
                        edges {
                            node {
                                fields {
                                    slug
                                }
                                frontmatter {
                                    title
                                    section
                                    nav_order
                                }
                            }
                        }
                    }
                }
            }
        `}
        render={(data) => (
            <NavMobile logo={data.logo} data={data.allMarkdownRemark} />
        )}
    />
)